import type { App } from 'vue'

let appended = false
function append(app: App) {
    if (appended) {
        return
    }
    appended = true
    const ckeditor = document.createElement('script')
    ckeditor.src = 'https://cdn.jsdelivr.net/npm/ckeditor5@48.4.0/dist/browser/ckeditor5.umd.js'
    ckeditor.id = 'ckeditor5-script'
    app._container?.appendChild(ckeditor)

    const style = document.createElement('link')
    style.rel = 'stylesheet'
    style.href = 'https://cdn.ckeditor.com/ckeditor5/48.4.0/ckeditor5.css'
    style.crossOrigin = 'anonymous'
    app._container?.appendChild(style)
}

export default defineNuxtPlugin({
    parallel: true,

    hooks: {
        'app:mounted'(app) {
            const settings = useSettings()
            watch(settings.richNoteEditor, (value) => {
                if (value) {
                    append(app)
                }
            }, { immediate: true })
        },
    },
})
